import React from "react";
import  "./Avatar.css";

const IMAGE_SIZE = 48;

const convertHexToRGBA = (hexCode, opacity = 1) => {
  if (!hexCode) {
    return "transparent";
  }
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  if (opacity > 1 && opacity <= 100) {
    opacity = opacity / 100;
  }

  return `rgba(${r},${g},${b},${opacity})`;
};

export function Avatar({ name, displayName, color, lastActive, scrollToUser, profilePicture, connectionId }) {
  if (!name || !color) {
    return null;
  }

  const now = new Date();
  const lastActiveTime = lastActive ? new Date(lastActive) : now;
  
  function getMinutesBetweenDates(startDate, endDate) {
    if (!startDate || !endDate) return 0;
    const diff = endDate.getTime() - startDate.getTime();
    return (diff / 60000);
  }

  // Show avatar for 1 hour (60 minutes) after last activity
  const minutesSinceLastActive = getMinutesBetweenDates(lastActiveTime, now);
  const shouldShowAvatar = minutesSinceLastActive <= 60;

  // Don't render avatar if user has been offline for more than 1 hour
  if (!shouldShowAvatar) {
    return null;
  }

  return (
    <div
      className={'avatar-container'}
      data-tooltip={`${displayName || name} (${connectionId})`}
      onClick={() => {
        console.log('🖱️ Avatar clicked:', { name, displayName, connectionId });
        // Try connectionId first, then fall back to name
        scrollToUser && scrollToUser(connectionId || name);
      }}
    >
      <p>{(name || '?').charAt(0).toUpperCase()}</p>
      <div
        style={{
          backgroundColor: profilePicture ? 'transparent' : convertHexToRGBA(color.dim || '#808080', 0.5),
          backgroundImage: profilePicture ? `url(${profilePicture})` : "",
          backgroundSize: "contain",
          userSelect: 'none',
          // ✅ FIX 1: Changed color.color to color.default to match the presence object
          boxShadow: `inset 0px 0px 0px 2px ${color.default || '#808080'}, 0px 8px 16px rgba(0,0,0,0.4)`,
          // ✅ FIX 2: Changed "BorderColor" to "borderColor" (camelCase) and used color.default
          borderColor: color.default || '#808080'
        }}
        alt={name}
        height={IMAGE_SIZE}
        width={IMAGE_SIZE}
        className={'avatar-background'}
      >
        <span className="avatar-text">
          {displayName || name}
          <br />
          <span
            style={{
              width: 'min-content',
              fontSize: '10px',
              zIndex: 9999
            }}
          >
            {minutesSinceLastActive <= 1 ? 
              "active now" : 
              shouldShowAvatar ? 
                'last active: ' + Math.round(minutesSinceLastActive) + " minutes ago" :
                "offline"
            }
          </span>
        </span>
      </div>
    </div>
  );
}